import { useEffect } from 'react'
import { useParams } from 'react-router'
import { branch, renderNothing } from 'recompose'

import { fetchPosts, queryPosts } from 'wordpress/actions'
import { Image } from 'wordpress/components'
import { withWordpressLanguage } from 'wordpress/utils'
import Meta from 'shared/components/Meta'
import { loadOnMount } from 'shared/hoc'

import { getLocationDataById } from 'booking/actions'
import { locationDetailsSelector } from 'booking/selectors'
import { postSelector } from '../selectors'
import contentToComponents from '../helpers'

import '../styles/content.scss'

const ContentPage = ({ post, getLocationDataById, locationDetails }) => {
    const { locationCode } = useParams()
    const showMonthlyParkingContent = Object.keys(locationDetails).length > 0
    const parkingLocation = {
        monthlyParkingLocation: locationDetails.name,
        locationState: locationDetails?.address?.state,
        locationCity: locationDetails?.address?.city,
    }

    useEffect(() => {
        if (locationCode) {
            getLocationDataById(locationCode)
        }
    }, [])

    return locationCode ? (
        showMonthlyParkingContent && (
            <div id="content" className="content">
                <Meta {...post} />
                <Image className="background" image={post.background} background />
                <div className="container">
                    <h1 className="monthlyParkingName">{locationDetails.name}</h1>
                    {post.content.map((c, i) => contentToComponents({ ...c, key: i, id: post.id, parkingLocation }))}
                </div>
            </div>
        )
    ) : (
        <div id="content" className="content">
            <Meta {...post} />
            <Image className="background" image={post.background} background />
            <div className="container">
                {post.content.map((c, i) => contentToComponents({ ...c, key: i, id: post.id }))}
            </div>
        </div>
    )
}

export default compose(
    withWordpressLanguage,
    connect(
        createStructuredSelector({
            post: postSelector,
            locationDetails: locationDetailsSelector,
        }),
        { fetchPosts, queryPosts, getLocationDataById }
    ),
    branch(
        props => props.slug,
        loadOnMount('queryPosts', ({ slug }) => ['content', { slug }]),
        loadOnMount('fetchPosts', props => ['content', [props.id]])
    ),
    branch(props => !props.post, renderNothing)
)(ContentPage)
